<script>
	import { onMount } from "svelte";
	import DetailsCard from "../../../components/DetailsCard/DetailsCard.svelte";
	import Tabs from "../../../components/Tabs/Tabs.svelte";
	import SubmittedPictures from "./SubmittedPictures.svelte";
	import Tasks from "./Tasks.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { statusMapStr } from "src/utils/options";
	import AuditTrail from "./AuditTrail.svelte";
	import TaskImages from "./TaskImages.svelte";
	import { getJobDetails } from "src/services/fmsTasking";

	export let jobId;

	let items = [
		{
			label: "Information",
			value: 1,
			component: DetailsCard,
		},
		{
			label: "Tasks",
			value: 2,
			component: Tasks,
		},
		{
			label: "Audit Trail",
			value: 3,
			component: AuditTrail,
		},
		{
			label: "Pre-Job Inspection",
			value: 4,
			component: SubmittedPictures,
		},
		{
			label: "All Task Images",
			value: 5,
			component: TaskImages,
		},
			  
	];

	let detailData;

	async function fetchJobById() {
		try {
			detailData = (await getJobDetails(jobId)).data;
		} catch (error) {
			console.error(error);
		}
	}
	onMount(async () => {
		await fetchJobById();
	});
</script>

{#if !detailData}
	<LoaderContainer />
{:else}
	<LoaderContainer>
		<div class="d-flex align-items-baseline">
			<div class="mx-1">
				<h5>{detailData.id}</h5>
			</div>
			<div class="mx-1">
				{@html statusMapStr[detailData.job.status]}
			</div>
		</div>
		<Tabs {items} {detailData} />
	</LoaderContainer>
{/if}
